import axios from "axios";
import React, {
  Component,
  useState,
  useEffect,
  useContext,
  lazy,
  Suspense,
} from "react";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import BitmediaAd from '../mission/bitmedia';
import AdSense from "react-adsense";
import { FaRegClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext";
import { Cookies } from "../../index.js";
import { ClipLoader } from "react-spinners";
import Login_google from './login';
import Buylink from './buylink.jsx';
const LazyReCAPTCHA = lazy(() => import("../../app_structure/LazyReCAPTCHA"));
function Capdo5(props) {
  const capdo = props.data;
  const money = props.money;
  const note = props.note;
  const [hustmediavipro, sethustmediavipro] = useState("");
  const [isLoading, setIsLoading] = useState("0");
  const [lienketjop, setlienketjop] = useState("");
  const [category, setcategory] = useState("");
  const [nutorder, setnutorder] = useState("Please wait a moment 😊");
  const [disabledbutton, setdisabledbutton] = useState(false);
  // Gọi hàm alert_error
  const [showquangcao, setshowquangcao] = useState(false);
  const recaptchaRef = React.createRef();
  const [nutxuly, setnutxuly] = useState("");
  const [show_input, set_show_input] = useState(false);
  const [code_input, setCode] = useState("");
  const [step, setstep] = useState("1");
  const [buttonTextjop, setButtontextjop] = useState(
    "Bình luận xong ấn đây để kiểm tra nhé");
  const [loading, setLoading] = useState(false);
  const [apikey, setapikey] = useState(false);
  const [chedo, setchedo] = useState("tiktokcmt");
  const [service, setservice] = useState("");
  const navigate = useNavigate();
  const handleClick = async () => {
    if (category != 'partner') {
      startcheck();
    }
    setTimeout(function () {
      window.open(lienketjop, "_blank");
    }, 300);
  };
  const startcheck = async () => {
    // console.log(capdo);
    set_show_input(true);
    if (step == 2) {
      if (capdo == 6 || capdo == 7) {
        setButtontextjop("Bình luận xong ấn đây để kiểm tra nhé");
      }
      else {
        setButtontextjop("Thả tim xong ấn đây để kiểm tra nhé");
      }
      setIsLoading(1);
    }
  };
  useEffect(() => {
    setservice("tiktokcmt");
    laydulieujop("tiktokcmt");
    const myCookieValue = Cookies.get('apikey');
    if (myCookieValue) {
      setapikey(myCookieValue);
    }
  }, []);

  function laydulieujop(value) {
    const hustmediavipro = Cookies.get("hustmediavipro");
    sethustmediavipro(hustmediavipro);
    setLoading(false);
    set_show_input(false);
    const fetchLienketjop = async () => {
      try {
        const response = await axios.get(
          "https://hust.media/jop/getjoplink.php?chedo=" + value + '&capdo=' + capdo + '&lienketcode=' + hustmediavipro
        );
        setlienketjop(response.data[0].lienketjop);
        setnutorder(response.data[0].textbutton);
        setcategory(response.data[0].category);
        setLoading(true);
      } catch (error) {
        alert_error("Lỗi xảy ra vui lòng load lại");
      }
    };

    fetchLienketjop();
  }
  function handleSubmit() {
    if (code_input) {
      checktim();
    }
    else {
      alert_error("Bạn chưa điền id tiktok");
    }
  };
  const checktim = async () => {
    setshowquangcao(1);
    const hustmediavipro = Cookies.get("hustmediavipro");
    const myCookieValue = Cookies.get('apikey');
    setButtontextjop("Please wait a moment 😊");
    let data = JSON.stringify({
      url: lienketjop,
      username: "hustmedia1",
      chedo: chedo,
      lienket: hustmediavipro,
      code_input: code_input,
      apikey: myCookieValue
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://hust.media/link/checktiktok.php",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .post(config.url, config.data, config.headers)
      .then((response) => {
        if (response.data.status == 1) {
          // setstep("3");
          setnutxuly(0);
          const lienketjop = response.data.order;
          console.log(lienketjop);
          props.onLienKetChange(lienketjop); // gọi hàm từ props để cập nhật liên kết trong component cha
          alert_success("Xác thực thành công");
          setdisabledbutton(true);
          setIsLoading("0");
          setButtontextjop("Hust Media cảm ơn bạn đã ghé thăm");
        } else if (response.data.status == 8) {
          setnutxuly(0);
          set_show_input(false);
          setLoading(false);
          // const lienketjop = response.data.order;
          // console.log(lienketjop);
          // props.onLienKetChange(lienketjop); // gọi hàm từ props để cập nhật liên kết trong component cha
          alert_success("Còn bước cuối là đến link");
          setdisabledbutton(false);
          setstep("2");
          setchedo("checktimhust");
          setIsLoading("0");
          setservice("checktimhust");
          laydulieujop("checktimhust");
          setButtontextjop("Hust Media cảm ơn bạn đã ghé thăm");
        } else if (response.data.status == 9) {
          setnutxuly(0);
          set_show_input(false);
          setLoading(false);
          // const lienketjop = response.data.order;
          // console.log(lienketjop);
          // props.onLienKetChange(lienketjop); // gọi hàm từ props để cập nhật liên kết trong component cha
          alert_success("Còn bước cuối là đến link");
          setdisabledbutton(false);
          setstep("2");
          setchedo("tiktokcmt");
          setIsLoading("0");
          setservice("tiktokcmt");
          laydulieujop("tiktokcmt");
          setButtontextjop("Hust Media cảm ơn bạn đã ghé thăm");
        }
        else if (response.data.status == 7) {
          setnutxuly(0);
          Cookies.set("capdovuotlink", 2, { expires: 1 / 12 }); // gọi hàm từ props để cập nhật liên kết trong component cha
          alert_success("Còn 1 bước nữa là đến liên kết");
          setButtontextjop("Xác thực thành công");
          //   setIsLoading("0");
          setTimeout(() => {
            navigate("/home2/");
          }, 1200);
        } else if (response.data.status == 2) {
          setButtontextjop("Vượt link thất bại");
          alert_error(response.data.error);
        } else {
          setButtontextjop("Vượt link thất bại");
          alert_error("Vượt link thất bại");
        }
        console.log(response.data.status);

        setButtontextjop("Thành công");
      })
      .catch((error) => {
        alert_error(error);
      });
  };

  return (
    <div>

      {showquangcao == 1 && (
        <Helmet>
          <script
            async="async"
            data-cfasync="false"
            src="//ophoacit.com/1?z=5904788"
          ></script>
        </Helmet>
      )}
      <div className="form-control">
        <div
          style={{ textAlign: "center" }}
          className="mt-0 justify-center items-center">
          <label className="mt-1 mb-0 text-sm flex justify-center items-center">Mô tả :</label>
          <div className="items-center mb-1">
            {note}
          </div>
          {apikey ? (<><Buylink money={money} hustmediavipro={hustmediavipro} /></>) : (<>
            <div className="mb-1 ">
              <div>Đăng nhập google để nhận link miễn phí</div>
              <Login_google />
            </div>
            <div className="mb-1 ">Hoặc:</div>
          </>)}
          {loading == false ? (
            <>
              {" "}
              <div>
                {" "}
                <div
                  className="spinner-border text-primary"
                  role="status"
                ></div>
                <span>Đang tải dữ liệu</span>
              </div>
            </>
          ) : (
            loading == true && (
              <>
                {!show_input ? (
                  <>
                    {" "}
                    <button
                      disabled={disabledbutton}
                      className="py-3 px-6 text-lg font-bold text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 rounded-lg shadow-md"
                      onClick={handleClick}
                    >
                      {nutorder}
                    </button>
                  </>
                ) : step == 1 ? (
                  <>
                    {" "}
                    <form>
                      <div className="relative flex">
                        <h2 className="text-xl font-bold text-black mb-2  w-full">
                          Nhập id tiktok:
                        </h2>
                        <button
                          disabled={nutxuly}
                          type="button"
                          className="bg-pink-400 text-white font-bold py-1 px-2 rounded-md ml-2"
                          onClick={() => laydulieujop(service)}
                        >
                          <span className="text-xs font-medium text-white">
                            Reload jop
                          </span>
                        </button>
                        <button
                          disabled={nutxuly}
                          type="button"
                          className="bg-pink-400 text-white font-bold py-1 px-2 rounded-md ml-2"
                          onClick={() => set_show_input(false)}
                        >
                          <span className="text-base font-medium text-white">
                            quay lại
                          </span>
                        </button>
                      </div>

                      <div className="relative flex">
                        <input
                          type="text"
                          className="border-2 border-pink-400 rounded-md p-3 pl-10 w-full focus:outline-none focus:border-pink-500"
                          placeholder="Nhập id ở đây"
                          value={code_input}
                          onChange={(e) => setCode(e.target.value)}
                        />
                        <div className="absolute left-3 top-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="h-6 w-6 text-pink-400"
                          >
                            {/* Icon sao chép */}
                          </svg>
                        </div>
                        <button
                          disabled={nutxuly}
                          type="button"
                          className="bg-pink-400 text-white font-bold py-2 px-3 rounded-md ml-2"
                          onClick={() => setIsLoading("1")}
                        >
                          {nutxuly == 1 && (
                            <div className="spinner-border" role="status"></div>
                          )}

                          <span className="text-lg font-medium text-white">
                            Xác nhận
                          </span>
                        </button>
                      </div>
                    </form>
                  </>
                ) : step == 2 ? (<>
                  <button
                    disabled={nutxuly}
                    type="button"
                    className="bg-pink-400 text-white font-bold py-1 px-2 rounded-md ml-2"
                    onClick={() => laydulieujop(service)}
                  >
                    <span className="text-xs font-medium text-white">
                      Reload jop
                    </span>
                  </button>
                  <button
                    disabled={nutxuly}
                    type="button"
                    className="bg-pink-400 text-white font-bold py-1 px-2 rounded-md ml-2"
                    onClick={() => set_show_input(false)}
                  >
                    <span className="text-base font-medium text-white">
                      quay lại
                    </span>
                  </button>

                  <div className="cards">
                    <AdSense.Google
                      client="ca-pub-4574266110812955"
                      slot="1627514116"
                      style={{ display: 'block' }}
                      format='horizontal'
                      responsive='false'
                    />
                  </div>

                </>) : (<></>)}

                {isLoading == 1 && (
                  <button
                    disabled={disabledbutton}
                    className="mt-2 py-3 px-6 text-lg font-bold text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 rounded-lg shadow-md"
                    onClick={handleSubmit}
                  >
                    {buttonTextjop != "Please wait a moment 😊" ? (
                      <span>{buttonTextjop}</span>
                    ) : (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline w-6 h-6 mr-2 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        {buttonTextjop}{" "}
                      </>
                    )}
                  </button>
                )}
              </>
            )
          )}
        </div>
      </div>
      <BitmediaAd />
      <div className="row fixrow">
        <div className="text-center">
          <button className="mx-2 btn btn-primary"
            onClick={() => window.open('https://hust.media/shop/content/blog_posts/freefltiktok/208', '_blank')}
          >
            Hướng dẫn
          </button>
        </div>
      </div>

    </div>
  );
}

export default Capdo5;
